<script setup>

 let props = defineProps(["title", "label"])
</script>

<template>
    <nav role="navigation" class="big-buttons">
        <button type="button" class="btn-image">
            <h2 class="btn-image-title"> {{ title }}</h2>
            <img src="/images/chemin-du-coeur.jpg" width="348" height="398" alt="" />
            <span class="btn-primary">{{ label }}</span>
        </button>

    </nav>
</template>

<style scoped>

</style>
